import useCategoryHook from "@/shared/hooks/useCategoryHook";
import { getCloudinaryFileId } from "@/shared/imageLibrary/aiImage";
import { Product } from "@/shared/utils/interfaces";

/**
 * Uploads a product image to Cloudinary and saves it on the product. AI images
 * from the library (passed as url) are only linked by their file id.
 */
const useProductImageSave = (product: Product, parentId: number) => {
  const { uploadImage, productUpdate } = useCategoryHook();

  return async (image: File | string) => {
    // Re-use the existing Cloudinary file so old images do not pile up.
    const fileId = product?.image_cloudinary_id?.split("/")?.[1]?.split(".")?.[0];
    const image_cloudinary_id =
      typeof image === "string"
        ? getCloudinaryFileId(image)
        : await uploadImage("item-image", image, fileId);
    await productUpdate.mutateAsync({
      ...product,
      topping_categories: product?.sub_content?.map((i) => i.item_id),
      parentId,
      image_cloudinary_id,
    });
  };
};

export default useProductImageSave;
